/**
 * Button Popup shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

// add popup functionality
import popup from '../util/popup';
popup({
	selectors: {
		wrap: '.button-popup',
		trigger: '.wp-block-button__link',
		popup: '.button-popup__inner > .wp-block-group',
		content: '.wp-block-group__inner-container',
	},
	lock: true,
});

// allow empty anchors to be tabbed to for accessibility
const buttonPopups = document.querySelectorAll('.button-popup');
buttonPopups && buttonPopups.forEach((el) => {
	const emptyLinks = el.querySelectorAll('a:not([href])');
	emptyLinks && emptyLinks.forEach((a) => {
		a.href = 'javascript:void(0);';
	});
});